import { render } from "./App.vue?vue&type=template&id=ab20a8a4&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=ab20a8a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ab20a8a4"

export default script